import { useEffect, createContext, useContext } from 'react';
import { useLocation } from 'react-router-dom';

const ThemeContext = createContext(null);

const isSuperAdminRoute = (pathname) => {
  return pathname.startsWith('/superadmin') ||
         pathname.includes('superadmin') ||
         pathname === '/admin';
};

export function ThemeProvider({ children }) {
  const location = useLocation();
  const isSuperAdmin = isSuperAdminRoute(location.pathname);
  const activeTheme = isSuperAdmin ? 'dark' : 'light';
  const isDark = isSuperAdmin;

  useEffect(() => {
    document.documentElement.setAttribute('data-theme', activeTheme);
  }, [activeTheme]);

  const value = {
    theme: activeTheme,
    isDark,
    isLight: !isDark,
    isSuperAdmin,
    canToggle: false,
    toggleTheme: () => {},
    setTheme: () => {},
  };

  return (
    <ThemeContext.Provider value={value}>
      {children}
    </ThemeContext.Provider>
  );
}

export function useTheme() {
  const context = useContext(ThemeContext);
  if (!context) {
    return {
      theme: 'light',
      isDark: false,
      isLight: true,
      isSuperAdmin: false,
      canToggle: false,
      toggleTheme: () => {},
      setTheme: () => {},
    };
  }
  return context;
}

export default useTheme;
